import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { PaperContent } from 'virtues-bootstrap';

import s from './styles.module.scss';

const UserInfo = ({ name, role, region, t }) => (
  <PaperContent>
    <div className={s.name} data-test="name">
      {name}
    </div>
    <div>
      {t(`roles.${role}`)} • {t(`site`)} {region ? `#${region}` : t('nullRegion')}
    </div>
  </PaperContent>
);

UserInfo.propTypes = {
  name: PropTypes.string,
  role: PropTypes.string,
  region: PropTypes.string,
  t: PropTypes.func.isRequired,
};

UserInfo.defaultProps = {
  name: null,
  role: null,
  region: null,
};

export default withTranslation()(UserInfo);
